<template>
    <div class="ca_body">
        <div class="ca_content" v-if="(currentContent && currentContent.content) || navigate.length > 0">
            <div class="ca_content_article Border_Radius_Big" id="article_main" ref="htmlWrapper">
                <div class="article_main">
                    <ca-preview-content
                        :content="currentContent.content"
                        refAttr="articleContentRef"
                        idAttr="articleContentRef"
                    ></ca-preview-content>
                </div>
            </div>

            <div class="ca_content_catalogue">
                <div class="catalogue_content">
                    <p class="title">{{ $t('ca.目录') }}</p>
                    <ca-catalogue
                        v-for="(item, index) in navigate"
                        :key="item.contentId"
                        :catalogue="item.title"
                        :activeName="activeName"
                        @handleClick="handleClick(item)"
                        @handle-empty="handleEmpty(item, index)"
                    ></ca-catalogue>
                </div>
            </div>
        </div>
        <cl-no-data v-else style="background:#fff;border-radius: 6px;"></cl-no-data>
    </div>
</template>

<script>
    import caCatalogue from './ca-catalogue.vue'
    import caPreviewContent from './ca-preview-content.vue'
    import CatKeyEvent from '@/mixins/CatKeyEvent.js'

    export default {
        mixins: [CatKeyEvent],
        data() {
            return {
                scroll: '',
                overSpace: 243, // 内容模块距离页面顶部的距离 - 距离元素多远触发
                contentData: {}, // 详情数据
                contentList: [], // 内容列表
                navigate: [], // 目录列表
                currentContent: {}, // 当前内容
                currentNavigate: {}, // 当前目录
                activeName: '',
            }
        },
        props: {
            detailsData: {
                type: Object,
                default: () => {},
            },
            source: {
                type: String,
                default: '',
            },
        },
        components: {
            caCatalogue,
            caPreviewContent,
        },
        watch: {
            //监听scroll变量，只要滚动条位置变化就会执行方法loadScroll
            scroll() {
                this.loadScroll()
            },
            // 当前内容改变时
            currentContent: {
                immediate: true,
                deep: true,
                handler(newV) {
                    if (newV && newV.content) {
                        this.currentContent.content = this.replaceVideoTag(this.currentContent.content)
                    }
                },
            },
            detailsData: {
                deep: true,
                handler() {
                    this.initFun()
                },
            },
        },
        methods: {
            // 初始化
            initFun() {
                this.contentData = this.detailsData
                this.contentList = this.contentData.contents || []
                if (this.contentList.length > 0) {
                    this.navigate = this.contentData.navigate ? JSON.parse(this.contentData.navigate) : []
                }
                if (this.navigate.length > 0) {
                    this.handleClick(this.navigate[0])
                }
            },
            // 原生video标签替换成cl-video-player组件
            replaceVideoTag(content) {
                content = content.replace(/<video/g, '<cl-video-player')
                content = content.replace(/><source/g, '')
                content = content.replace(/type="video\/.{3}" \/>/g, '/>')
                content = content.replace(/<\/video>/g, '')
                return content
            },
            // 分析文章详情
            async analysisContent() {
                await this.$nextTick()
                let contentEle = document.getElementById('articleContentRef')
                let h1 = contentEle.getElementsByTagName('h1')
                let h2 = contentEle.getElementsByTagName('h2')
                let h3 = contentEle.getElementsByTagName('h3')
                const arr = [...h1, ...h2, ...h3]
                const titles = this.$utils.deepCopy(this.currentNavigate.title)
                arr.forEach((item) => {
                    item.classList = 'ca-title'
                })

                const domArr = contentEle.querySelectorAll('.ca-title')
                domArr.forEach((item) => {
                    const index = titles.findIndex((item2) => item2.name === item.innerText)
                    if (index > -1) {
                        item.id = titles[index].local_id
                        titles.splice(index, 1)
                    }
                })
            },
            // titleItem/点击的目录单项 navigateItem/点击的目录父级 结构为{ contentId: '', title: [] }
            async handleClick(navigateItem) {
                const params = {
                    tenant_id: this.detailsData.tenant_id
                }
                const { code, data } = await this.$server.campContentApi(params, navigateItem.contentId)
                if (code === 200) {
                    this.currentContent = data
                    this.activeName = navigateItem.title[0]?.local_id
                    this.currentNavigate = navigateItem
                    this.analysisContent()
                }
            },
            /**
             * @description 处理目录item为空时，点击也可以切换内容。
             * @param item {object} 目录item
             */
            handleEmpty(item) {
                if (this.currentContent.id !== item.contentId) {
                    this.handleClick(item)
                }
            },
            /* 下一章 */
            nextContent() {
                let index = this.navigate.findIndex((item) => item.contentId === this.currentContent.id)
                if (index > -1 && index + 1 < this.navigate.length) {
                    this.handleClick(this.navigate[index + 1])
                }
            },

            /* 上一章 */
            preContent() {
                let index = this.navigate.findIndex((item) => item.contentId === this.currentContent.id)
                if (index > -1 && index - 1 >= 0) {
                    this.handleClick(this.navigate[index - 1])
                }
            },

            dataScroll() {
                this.scroll = document.getElementById('article_main').scrollTop
            },
            jump(id) {
                document.getElementById(id)?.scrollIntoView(true)
                // let jump = document.getElementById(id);
                // 获取需要滚动的距离
                // let total = jump.offsetTop;
                // document.getElementById('article_main').scrollTop = total;
            },
            // 用循环的方式将每个标题离顶部的距离与滚动条当前位置对比来确定哪个标题需要变为高亮
            loadScroll() {
                let contentEle = document.getElementById('articleContentRef')
                let allTitle = contentEle.querySelectorAll('.ca-title')
                for (let i = allTitle.length - 1; i >= 0; i--) {
                    if (this.scroll >= allTitle[i].offsetTop - this.overSpace) {
                        //每个el-tab-pane标签的name属性值为tab+该标签的index值
                        this.activeName = allTitle[i].id
                        break
                    }
                }
            },
            // 格式化价格
            formatPrice(coursePrice, num = 2) {
                let price = coursePrice.toFixed(num)
                return price
            },
        },
        created() {
            this.initFun()
        },
        mounted() {
            // scroll代表滚动条距离页面顶部距离
            if (document.getElementById('article_main')) {
                document.getElementById('article_main').addEventListener('scroll', this.dataScroll)
            }
        },
    }
</script>

<style lang="scss" scoped>
    .ca_body {
        width: 100%;
        height: 100%;
    }
    .ca_content {
        display: flex;
        height: 100%;
        .ca_content_article {
            overflow-y: auto;
            box-sizing: border-box;
            width: 100%;
            max-height: 100%;
            flex: 1;
            padding: 30px;
            background: #ffffff;
            box-shadow: 0px 16px 16px rgba(186, 186, 186, 0.12);
            border-radius: 4px;
            .article_title {
                font-family: PingFang SC;
                font-style: normal;
                font-weight: 500;
                font-size: 24px;
                line-height: 34px;
                color: #080808;
                word-break: break-all;
            }
            .article_info_item {
                padding: 4px 14px;
                background: rgba(115, 107, 209, 0.12);
                color: #796ff6;
                border-radius: 8px;
                i {
                    font-style: normal;
                }
            }
        }
        .ca_content_catalogue {
            display: flex;
            flex-direction: column;
            overflow: hidden;
            width: 330px;
            height: 100%;
            margin-left: 16px;
            background: #fff;
            border-radius: 4px;
            .article_title {
                overflow: hidden;
                display: -webkit-box;
                width: 85%;
                max-height: 64px;
                font-family: PingFang SC;
                font-style: normal;
                font-weight: 500;
                font-size: 18px;
                line-height: 29px;
                color: #fff;
                word-break: break-all;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                text-overflow: ellipsis;
            }
            .option_btn {
                position: relative;
                width: 100%;
                height: 50px;
            }
            .pay_btn {
                width: 200px;
                height: 50px;
                background: #fed371;
                text-align: center;
                font-family: PingFang SC;
                font-style: normal;
                font-weight: 600;
                font-size: 18px;
                line-height: 50px;
                color: #8c5a2c;
                border-radius: 16px;
                cursor: pointer;
            }
            .catalogue_content {
                flex: 1;
                box-sizing: border-box;
                overflow-y: auto;
                padding: 16px 24px;
                background: #fff;
                box-shadow: 0px 16px 16px rgba(186, 186, 186, 0.12);
                .title {
                    padding: 0 4px;
                    font-family: 'PingFang SC';
                    font-style: normal;
                    font-weight: 500;
                    font-size: 18px;
                    line-height: 25px;
                    color: #3a3a3a;
                }
            }
        }

        /deep/.article_main {
            line-height: normal;
            @include reset();
        }
    }
</style>
